<template>
	<nav
		class="flex select-none items-center gap-4 border-b pb-[19px] pl-2.5 pr-5 pt-5 transition-[border-color] lg:pl-7"
		:class="{
			'border-transparent': !border || stickyTop,
			'border-separator-primary': border && !stickyTop
		}"
	>
		<div class="flex items-center">
			<MenuDropdown :routes="routes" class="lg:hidden" />
			<RouterLink to="/undress" custom v-slot="{ navigate }">
				<LogoIcon
					class="w-auto min-w-fit cursor-pointer text-pink hover:brightness-90 focus:scale-95 focus:transform active:scale-95 active:transform max-lg:ml-1.5"
					@click="navigate"
					id="logo-desktop"
				/>
			</RouterLink>
		</div>
		<div class="flex items-center max-lg:hidden">
			<Component
				v-for="route in routes"
				:is="route.as ?? 'RouterLink'"
				:to="!route.as ? route.to : undefined"
				class="cursor-pointer truncate px-3 py-2.5 text-sm font-medium text-label-secondary hover:text-label-primary focus:text-label-primary focus:outline-none active:scale-95 active:transform"
				:class="{
					'!text-pink':
						currentRoute.path === '/affiliates' &&
						route.to === '/affiliates-landing'
				}"
				:exactActiveClass="!route.as ? '!text-pink' : undefined"
				:href="route.as ? route.to : undefined"
				:target="route.as ? '_blank' : undefined"
			>
				{{ route.name }}
			</Component>
		</div>
		<div class="ml-auto flex items-center gap-2">
			<template v-if="user.loading">
				<LoadingSkeleton
					class="h-10.5 w-10.5 bg-fill-tertiary dark:bg-fill-primary"
				/>
				<LoadingSkeleton
					class="h-10.5 w-16 bg-fill-tertiary dark:bg-fill-primary"
				/>
			</template>
			<template v-else>
				<template v-if="user.current">
					<BaseButton size="md" color="blue" @click="open('TopUp')">
						<template #leftIcon>
							<CartIcon />
						</template>
						{{ t('TheNavbar.buyCredits') }}
					</BaseButton>
					<BaseCard
						class="flex h-10.5 items-center gap-1.5 rounded-xl pl-[11px] pr-[13px] text-sm font-medium text-label-primary"
					>
						<CreditIcon class="h-5 w-5" />
						<div>{{ user.current.totalCredits }}</div>
					</BaseCard>
					<UserDropdown>
						<UserAvatar
							:username="user.current.name"
							:avatar="user.current.avatar ?? undefined"
							class="h-10.5 w-10.5 !text-md"
						/>
					</UserDropdown>
				</template>
				<template v-else>
					<ThemeButton />
					<BaseButton size="md" color="pink" @click="open('SignIn')">
						{{ t('TheNavbar.signIn') }}
					</BaseButton>
				</template>
			</template>
		</div>
	</nav>
</template>
<script setup lang="ts">
import LogoIcon from '../assets/icons/logo.svg'
import BaseButton from './BaseButton.vue'
import CartIcon from '../assets/icons/cart.svg'
import CreditIcon from '../assets/icons/credit.svg'
import { computed } from 'vue'
import BaseCard from './BaseCard.vue'
import UserAvatar from './UserAvatar.vue'
import { useModalStore } from '../stores/modal'
import { useUserStore } from '../stores/user'
import MenuDropdown from './MenuDropdown.vue'
import { useI18n } from 'vue-i18n'
import UserDropdown from './UserDropdown.vue'
import LoadingSkeleton from './LoadingSkeleton.vue'
import ThemeButton from './ThemeButton.vue'
import { useRoute } from 'vue-router'

const { t } = useI18n()

defineProps<{
	border?: boolean
}>()

const user = useUserStore()

const routes = computed(() => {
	const result: {
		to: string
		name: string
		as?: 'a'
	}[] = [
		{
			to: '/undress',
			name: t('TheNavbar.undress')
		},
		{
			to: '/ai-models',
			name: t('TheNavbar.models')
		},
		{
			to: '/my-gallery',
			name: t('TheNavbar.gallery')
		},
		{
			to: `https://p2p.nubeeai.com/${user.current ? `?uuid=${user.current.uuid}` : ''}`,
			name: t('TheNavbar.p2p'),
			as: 'a'
		},
		{
			to: '/api',
			name: 'API'
		},
		{
			to: '/affiliates-landing',
			name: t('TheNavbar.referrals')
		}
	]

	return result
})

const { open } = useModalStore()

const currentRoute = useRoute()

console.log(currentRoute)

const stickyTop = computed(
	() => currentRoute.meta && currentRoute.meta.stickyTop
)
</script>
